import React from 'react';
import { Card } from '../../../shared/components';

interface FieldProps {
  label: string;
  value: string;
}

const Field: React.FC<FieldProps> = ({ label, value }) => (
  <div className="py-2">
    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{label}</p>
    <p className="mt-0.5 text-sm font-medium text-gray-800">{value}</p>
  </div>
);

interface FieldGroupProps {
  title:   string;
  fields:  FieldProps[];
  columns?: 2 | 3;
}

/** Renderiza un grupo de campos dentro de una Card. */
export const FieldGroup: React.FC<FieldGroupProps> = ({ title, fields, columns = 3 }) => {
  if (fields.length === 0) return null;
  const gridCls = columns === 3
    ? 'grid grid-cols-2 sm:grid-cols-3'
    : 'grid grid-cols-1 sm:grid-cols-2';
  return (
    <Card title={title}>
      <div className={gridCls}>
        {fields.map(({ label, value }) => (
          <Field key={label} label={label} value={value} />
        ))}
      </div>
    </Card>
  );
};
